import React from 'react';
import ThumbOverlayDefault from '@wix/da-ds/pkg/thumbs/ThumbOverlayDefault';
import DeviationMediaService from '../../../../utils/DeviationMediaService';
import { normalizePremiumFolderData } from '../../../../utils/normalizePremiumFolderData';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { getSource, isGifDeviation, isVideoDeviation } from '../../../_helpers';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
function getMediaType(deviation) {
    if (isVideoDeviation(deviation)) {
        return 'video';
    }
    if (isGifDeviation(deviation)) {
        return 'gif';
    }
}
function getDuration(deviation) {
    const videoFile = getSource(DeviationMediaService.getMediaByType(deviation, 'video'));
    return videoFile === null || videoFile === void 0 ? void 0 : videoFile.duration;
}
function getIndicators(deviation) {
    const indicators = [];
    if (deviation.primaryTier) {
        indicators.push('in-tier');
    }
    const { isWatchToAccess , isPaidFolder  } = normalizePremiumFolderData(deviation.premiumFolderData);
    if (isPaidFolder) {
        indicators.push('in-premium');
    }
    if (isWatchToAccess) {
        indicators.push('in-watchers-only');
    }
    // TODO: add PCP if/when they want it
    // TODO: add NFT when relevant
    return indicators;
}
const DeviationThumbOverlayDefault = ({ deviation , width , height , isFaved , hasCommentedOn , children , className  })=>{
    const blockType = useDeviationBlockType(deviation);
    const { showPermanentEngagementIcon , showDailyDeviationLabel , showMediaIndicators , showThumbStatusIndicators  } = useOverlayContext(deviation);
    return /*#__PURE__*/ React.createElement(ThumbOverlayDefault, {
        width: width,
        height: height,
        isDailyDeviation: showDailyDeviationLabel && deviation.isDailyDeviation,
        isFaved: showPermanentEngagementIcon && isFaved,
        isCommented: showPermanentEngagementIcon && hasCommentedOn,
        statusIndicators: showThumbStatusIndicators && !blockType ? getIndicators(deviation) : undefined,
        mediaIndicator: showMediaIndicators && !blockType ? getMediaType(deviation) : undefined,
        duration: getDuration(deviation),
        className: className
    }, children);
};
DeviationThumbOverlayDefault.displayName = 'DeviationThumbOverlayDefault';
export default DeviationThumbOverlayDefault;
